/* eslint-disable camelcase */
import type { AppPlatformType } from "@lib/dashboardConfig";
import sharedConstants from "@lib/shared_constants.json";

export interface AppleCredentialData {
  id: string;
  valid: boolean;
  bundle_id: string;
  team_id?: string;
  key_id?: string;
  use_development_gateway: boolean;
  certificate_id?: string;
  password?: string;
  expiration?: number;
  type?: string;
}

export interface AppleCredentialDataRequest {
  push_certificate: {
    certificate_id: string;
    jwt_bundle_id: string;
    jwt_key_id: string;
    jwt_team_id: string;
    use_development_gateway: boolean;
    password: string;
  };
}

const providerTypes = sharedConstants.COMMUNICATION.PUSH_PROVIDER_TYPES;

export interface FirebaseCredentialData {
  push_provider_type: typeof providerTypes.FIREBASE;
}

export interface HuaweiCredentialData {
  push_provider_type: typeof providerTypes.HUAWEI;
  huawei_app_secret: string;
  huawei_app_id: string;
}

export interface WindowsCredentialData {
  sid: string;
  client_secret: string;
}

// Also referred to as ADM / AMZ
export interface KindleCredentialData {
  client_id: string;
  client_secret: string;
}

export interface SafariCredentialData {
  id?: string;
  valid?: boolean;
  bundle_id?: string;
  expiration?: number;
  website_name: string;
  allowed_domains: string[];
  image_url?: string;
  image_id?: string;
  certificate_id?: string;
  password?: string;
}

export interface SafariCredentialDataRequest {
  website_name: string;
  allowed_domains: Array<string>;
  image_id: string;
  push_certificate: {
    certificate_id: string;
    password?: string;
  };
}

// Data receive from the server when we request for push credential data on initial load
export type PushCredentialData =
  | AppleCredentialData
  | FirebaseCredentialData
  | HuaweiCredentialData
  | WindowsCredentialData
  | KindleCredentialData
  | SafariCredentialData;

// Data that is sent to the server when a user saves their request
export type PushCredentialDataRequest =
  | Omit<PushCredentialData, "SafariCredentialData" | "AppleCredentialData">
  | AppleCredentialDataRequest
  | SafariCredentialDataRequest;

export interface AppsAppIdPushCredentialResult {
  credential?: {
    app_type: AppPlatformType;
    credential_data?: PushCredentialData;
  };
}

export interface PostAppsAppIdPushCredentialProps {
  appId: string;
  data: PushCredentialDataRequest;
}

export interface DeleteAppsAppIdPushCredentialProps {
  appId: string;
}

/* eslint-disable camelcase */
